import dayjs from "dayjs";
import CryptoJS from 'crypto-js';
import { AES_IV, AES_KEY } from "../config/constants";

// *Date Formate
export const DateFormate = "DD-MM-YYYY"

// *Email Regex
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// *Password Regex
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_~=@#$>.<,[{}()!%\|'"`:;+*?&])[A-Za-z\d_~=@#$>.<,[{}()!%\|'"`:;+*?&]{8,}$/

// *No Double Quotes 
export const noDoubleQuotes = (message = 'Double quotes (") are not allowed.') => ({
  pattern: {
    value: /^[^"]*$/,
    message: message
  }
});

// *For Debounce
let debounceTimer;
export const Debounce = (func, delay = 1000) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
};

export const getDate = (date) => {
  if (!date) return
  const newDate = dayjs(date).format('DD-MM-YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
};

export const getMonthDate = (date) => {
  if (!date) return
  const newDate = dayjs(date).format('DD/MMM/YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
};

export const getMonthYear = (date) => {
  if (!date) return
  const newDate = dayjs(date).format('MMM YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
};

// *Format the amount with commas
export const CommaSeparator = (value, fractionDigits = 2) => {
  if (isNaN(value)) {
    return 0
  }
  else {
    let result = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits
    }).format(value)

    return result
  }
}

// *For get file size into Bytes, KB and MB
export const getFileSize = (size) => {
  let fileSize
  if (size < 1024) {
    fileSize = `${size} Bytes`
  } else if (size < 1024 * 1024) {
    const fileSizeInKBs = size / 1024;
    fileSize = `${fileSizeInKBs.toFixed(2)} KB`
  } else {
    const fileSizeInMBs = size / (1024 * 1024);
    fileSize = `${fileSizeInMBs.toFixed(2)} MB`
  }
  return fileSize
}

// *For AES Encryption
const key = CryptoJS.enc.Hex.parse(AES_KEY);
const iv = CryptoJS.enc.Hex.parse(AES_IV);

export function encryptText(text) {
  if (!text) return "";
  const encrypted = CryptoJS.AES.encrypt(text, key, { iv });
  return encrypted.toString();
}

export const cleanObject = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== null && v !== undefined
    )
  );